import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DropdownCardMenu from 'common/components/DropdownCardMenu';

const ActionsFormatter = ({ handleClickUpdate, row }) => {
    const { t } = useTranslation();

    const renderOptions = () => {
        return (
            <DropdownCardMenu
                items={[
                    {
                        handleClick: () => handleClickUpdate(row?.id),
                        icon: <EditIcon fontSize="small" />,
                        label: t('Edit'),
                    },
                ]}
            />
        );
    };

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                gap: '4px',
                justifyContent: 'end',
                width: '100%',
            }}
        >
            {renderOptions()}
        </Box>
    );
};

ActionsFormatter.propTypes = {
    handleClickUpdate: PropTypes.func,
    row: PropTypes.object,
};

export default ActionsFormatter;
